import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { AbstractControl, FormControl } from '@angular/forms';
import { ApplicationContextService, RolePermissionService } from 'lib-core-shared';
import { ControlBaseDirective } from '../../directives/control-base.directive';

@Component({
  selector: 'lib-text-area',
  templateUrl: './text-area.component.html',
  styleUrls: ['./text-area.component.css']
})
export class TextAreaComponent extends ControlBaseDirective {

  @ViewChild('someVar') el!:ElementRef;

  constructor(public roleService: RolePermissionService, public applicationContext: ApplicationContextService) { 
    super(roleService, applicationContext);
  }

  public ngAfterViewInit(): void {
  }
}

